import Decimal from 'decimal.js-light';

export const formatDeviceSerial = (name: string) => {
  if (name.length === 8) {
    return `${name.substring(0, 4)}-${name.substring(4, 8)}`.toUpperCase();
  }
  return name;
};

const trimTrailingZeros = (value: string) =>
  value.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');

const formatDecimalNumber = (
  value: string | number,
  precision?: number,
  rounding = Decimal.ROUND_DOWN,
) => {
  if (typeof value === 'string' && value.trim() === '') {
    return value;
  }

  try {
    const decimal = new Decimal(value);
    const formattedValue = trimTrailingZeros(
      precision == null
        ? decimal.toFixed()
        : decimal.toDecimalPlaces(precision, rounding).toFixed(precision),
    );

    return formattedValue === '-0' || formattedValue === '' ? '0' : formattedValue;
  } catch (error) {
    return String(value);
  }
};

export const formatPreciseNumber = (value: string | number) => formatDecimalNumber(value);

export const formatNumberWithPrecision = (value: string | number, precision = 3) =>
  formatDecimalNumber(value, precision);
